export const APPROVAL_REQUEST_TABLE_PAGE_SIZE = 10;

export const DEBOUNCE_DELAY_TIME = 1000;

export const APPROVAL_REQUEST_BULK_LIMIT = 20;
